var ScrollManager = function () {

    var _instance;

    function _ScrollManager() {
        var self = this;

        var numThreshold = 0;
        var numCurrentScrollPosition;
        var numMovedScrollPosition;
        var sCurrentDirection;
        var aCustomEvent = {
            scrollUp: [],
            scrollDown: [],
            scroll: []
        };

        /**
        * scrollUp event가 발생한 뒤에 수행할 함수 지정
        * @param customFunc
        */
        this.addScrollUpEventListener = function (customFunc) {
            if (customFunc && customFunc instanceof Function) {
                aCustomEvent.scrollUp.push(customFunc);
            }
        };

        /**
        * scrollDown event가 발생한 뒤에 수행할 함수 지정
        * @param customFunc
        */
        this.addScrollDownEventListener = function (customFunc) {
            if (customFunc && customFunc instanceof Function) {
                aCustomEvent.scrollDown.push(customFunc);
            }
        };

        /**
        * scroll event가 일어났을때 수행할 함수 지정
        * @param customFunc
        */
        this.addScrollEventListener = function (customFunc) {
            if (customFunc && customFunc instanceof Function) {
                aCustomEvent.scroll.push(customFunc);
            }
        };

        this.getBeforeScrollPosition = function () {
            return numCurrentScrollPosition;
        };

        this.getAfterScrollPosition = function () {
            return numMovedScrollPosition;
        };

        this.getThreshold = function () {
            return numThreshold;
        };

        this.setThreshold = function (numNewThreshold) {
            numThreshold = numNewThreshold;
        };

        var triggerOnScroll = function (aTarget) {
            for (var i = 0; i < aTarget.length; i++) {
                aTarget[i].apply(self);
            }
        };

        var _init = function () {

            // window scroll event
            numCurrentScrollPosition = $(window).scrollTop();

            window.addEventListener('scroll', function () {
                numMovedScrollPosition = $(window).scrollTop();

                // threshold
                if (Math.abs(numCurrentScrollPosition - numMovedScrollPosition) > numThreshold) {

                    // scroll up
                    if (numCurrentScrollPosition >= numMovedScrollPosition) {
                        self.sCurrentDirection = 'up';
                        triggerOnScroll(aCustomEvent.scrollUp);
                    }

                    // scroll down
                    else if (numCurrentScrollPosition < numMovedScrollPosition) {
                        self.sCurrentDirection = 'down';
                        triggerOnScroll(aCustomEvent.scrollDown);
                    }

                    // scroll (default)
                    triggerOnScroll(aCustomEvent.scroll);
                }

                self.sCurrentDirection = '';

                numCurrentScrollPosition = numMovedScrollPosition;
            });

            return self;
        };

        _init();
    }

    function _getInstance() {
        if (_instance === undefined) {
            _instance = new _ScrollManager();
        }

        return _instance;
    }

    return _getInstance();
};

/**
 * 세로로 동작하는 슬라이더
 * @namespace
 */
var VerticalSlider = {

    /**
    * 실시간 급상승 검색어 (하드코딩됨)
    * @param options vTicker option을 확장
    */
    keywordRankingLive: function (options) {
        var self = $('div.m_newsch');
        var oListArea = self.find('div.m_nslistarea');

        /**
        * 슬라이더 열기
        * @private
        */
        var _open = function () {
            oListArea.vTicker('pause', true);
            self.removeClass('m_sch_close');
            oListArea.hide();
            self.find('.nslistarea-slider').show();
        };

        /**
        * 슬라이더 닫기
        * @private
        */
        var _close = function () {
            oListArea.vTicker('pause', false);
            self.addClass('m_sch_close');
            oListArea.show();
            self.find('.nslistarea-slider').hide();
        };

        /**
        * 슬라이더 토글
        * @private
        */
        var _toggle = function () {
            if (self.is('.m_sch_close')) {
                _open();
            } else {
                _close();
            }
        };

        /**
        * 슬라이더 초기화
        */
        var _initSlider = function () {
            var clone = oListArea.clone().addClass('nslistarea-slider');
            self.append(clone);

            // ticker 기본값 세팅해둠
            var oTicker = oListArea.vTicker($.extend(options, {
                speed: 700,
                pause: 4000,
                showItems: 1,
                mousePause: true,
                height: 0,
                animate: true,
                margin: 0,
                padding: 0,
                startPaused: false
            }));

            // 보여지는 상태에 따라 슬라이더 혹은 복제품을 toggle
            if (self.is('.m_sch_close')) {
                clone.hide();
                oListArea.show();

                oListArea.find('a.box').on('click', function (e) {
                    e.preventDefault();
                    _open();
                });
            } else {
                clone.show();
                oListArea.hide();
            }

            // 토글 버튼 바인딩
            self.find('a.btn_ns').on('click', function (e) {
                e.preventDefault();
                _toggle();
            });


        };

        _initSlider();
    }
};



/**
 * anchor태그 href attribute에 넣은 값 (예: #targetExmample)으로 대상 레이어를 토글링하는 기능
 * href attribute가 아니더라도 data-toggle-target에 대상 selector를 대신하거나 더 추가할 수 있음
 * @constructor
 * @param options
 * @example anchor태그의 class에 toggleSelector의 값을 넣고 href attribute에는 대상이 될 id를 적는다.
 */
var Toggler = function(options) {
    options = $.extend({
        toggleSelector: '.ssg-toggle',
        toggleSelectorByDataAttr: 'toggle-target',
        hoverSelector: '.ssg-toggle-hover',
        modalSelector: '.ssg-toggle-modal',
        modalMaskSelector: '.ssg-toggle-modal-mask',
        closeButtonSelector: '.ssg-toggle-close',
        buttonActiveClassName: 'active',
        viewActiveClassName: null
    }, options);



    /**
     * 대상을 토글링 한다
     * @param {element} target 대상 element
     * @param {string} showOrHide 'active' or 'deactive'
     * @param {string} className 토글할 class명
     * @private
     */
    var _toggle = function(target, showOrHide, className) {
        if(className) {
            if(showOrHide === 'active') {
                target.addClass(className);
            } else if(showOrHide === 'deactive') {
                target.removeClass(className);
            } else if(showOrHide === 'toggle') {
                target.toggleClass(className);
            }
        }

        else {
            if(showOrHide === 'active') {
                target.show();
            } else if(showOrHide === 'deactive') {
                target.hide();
            } else if(showOrHide === 'toggle') {
                target.toggle();
            }
        }
    };



    /**
     * ModalMask 레이어가 없는 경우 기본값으로 생성해준다
     * @private
     */
    var _createModalMask = function() {
        var mask = $('<div>').css({
            'width': '100%',
            'position': 'absolute',
            'top': 0,
            'left': 0,
            'display': 'none',
            'z-index': 3000,
            'background-color': 'rgba(0,0,0,.8)'
        }).addClass(options.modalMaskSelector.replace('.', ''));

        $('body').append(mask);
    };



    /**
     * ModalMask 레이어의 가로세로 사이즈를 문서 사이즈에 맞게 변경
     * @private
     */
    var _resizeModalMask = function() {
        $(options.modalMaskSelector).width('100%').height($(document).height());
    };


    /**
     * 대상이 가시상태인지 확인
     * @param target 대상
     * @returns {boolean}
     * @private
     */
    var _isVisibleTarget = function(target) {
        if(options.viewActiveClassName) {
            if(target.is('.' + options.viewActiveClassName)) {
                return true;
            } else {
                return false;
            }
        }

        else {
            if(target.is(':visible')) {
                return true;
            } else {
                return false;
            }
        }
    };



    /**
     * 현재 토글 버튼을 가져온다
     * @param toggleSelector 토글버튼 선택자
     * @param eventTarget 발생한 이벤트의 타겟 (ex: event.target)
     * @returns {jquery element} 현재 토글 버튼
     * @private
     */
    var _getCurrentToggle = function(toggleSelector, eventTarget) {
        var currentTarget = $(eventTarget);

        if(currentTarget.is(toggleSelector)) {
            return currentTarget;
        } else {
            return currentTarget.parents(toggleSelector);
        }
    };



    var _init = function() {

        // 토글 버튼 이벤트 작성
        $('body')

            /**
             * show normal layer
             */
            .on('toggleon.toggler', options.toggleSelector, function(e) {
                var currentToggle = _getCurrentToggle(options.toggleSelector, e.target);
                var currentTargetView = $(currentToggle.attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr));

                // 닫기 버튼
                currentTargetView.on('click.toggler', options.closeButtonSelector, function(e) {
                    e.preventDefault();

                    currentToggle.trigger('toggleoff');
                    $(this).unbind('click.toggler');
                });

                _toggle(currentToggle, 'active', options.buttonActiveClassName);
                _toggle(currentTargetView, 'active', options.viewActiveClassName);
            })

            /**
             * hide normal, modal layer
             */
            .on('toggleoff.toggler', options.toggleSelector, function(e) {
                var currentToggle = _getCurrentToggle(options.toggleSelector, e.target);
                var currentTargetView = $(currentToggle.attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr));
                var modalMask = $(options.modalMaskSelector);

                _toggle(currentToggle, 'deactive', options.buttonActiveClassName);
                _toggle(currentTargetView, 'deactive', options.viewActiveClassName);
                _toggle(modalMask, 'deactive');
            })

            /**
             * show modal layer
             */
            .on('togglemodalon.toggler', options.toggleSelector, function(e) {
                var currentToggle = _getCurrentToggle(options.toggleSelector, e.target);
                var currentTargetView = $(currentToggle.attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr));
                var modalMask = $(options.modalMaskSelector);

                // setting for Modal Mask Layer
                // modal mask가 없는 경우 기본 세팅으로 생성
                if(modalMask.length <= 0) {
                    _createModalMask();
                }

                modalMask = $(options.modalMaskSelector).css('z-index', 9000);
                _resizeModalMask();



                // setting for Target View Layer
                // target z-index 세팅
                currentTargetView.css('z-index', 10000);

                // target 위치 조정 (정가운데로)
                var topPosition = Math.max($(window).scrollTop() + $(window).height() / 2 - currentTargetView.outerHeight() / 2, 0);

                currentTargetView.css({
                    position: 'absolute',
                    left: $(window).width() / 2 - currentTargetView.outerWidth() / 2,
                    top: topPosition
                });



                _toggle(modalMask, 'active');                   // modal mask 보이기

                currentToggle.trigger('toggleon');              // trigger default toggleon
            })

            /**
             * trigger click toggle
             */
            .on('click.toggler', options.toggleSelector, function(e) {
                e.preventDefault();

                var currentToggle = _getCurrentToggle(options.toggleSelector, e.target);
                var currentTargetView = $(currentToggle.attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr));

                if(currentToggle.is(options.hoverSelector)) {
                    return;
                }

                if(currentToggle.is(options.modalSelector)) {
                    currentToggle.trigger('togglemodalon');
                    return;
                }

                if(_isVisibleTarget(currentTargetView)) {
                    currentToggle.trigger('toggleoff');
                    return;
                }

                currentToggle.trigger('toggleon');

                var globalToggleOff = function(e) {
                    var isPass = $(e.target).is(currentToggle);

                    if(isPass) {
                        return;
                    }

                    isPass = isPass || $(e.target).is(currentTargetView);
                    isPass = isPass || currentTargetView.has(e.target).length > 0;
                    isPass = isPass || currentTargetView.is($($(e.target).attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr)));

                    if(!isPass) {
                        currentToggle.trigger('toggleoff');
                    } else {
                        $('body').one('click.toggler', globalToggleOff);
                    }
                };

                $('body').one('click.toggler', globalToggleOff);
            })

            /**
             * trigger hover toggle
             */
            .on('mouseenter.toggler focusin.toggler', options.hoverSelector, function(e) {
                var currentToggle = _getCurrentToggle(options.toggleSelector, e.target);
                var currentTargetView = $(currentToggle.attr('href')).add(currentToggle.data(options.toggleSelectorByDataAttr));

                currentToggle.trigger('toggleon');

                currentToggle.add(currentTargetView).one('mouseleave.toggler focusout.toggler', function(e) {
                    var isPass = !e.relatedTarget;
                    isPass = isPass || $(e.relatedTarget).is(currentToggle);
                    isPass = isPass || $(e.relatedTarget).is(currentTargetView);
                    isPass = isPass || currentTargetView.has(e.relatedTarget).length > 0;

                    if(!isPass) {
                        currentToggle.trigger('toggleoff');
                    }
                });
            });
    };

    _init();
};



/**
 * textarea용 fake placeholder
 * @type {*}
 */
var Placeholder = {

    load: function(target) {
        $(target).on({
            'click': function(e) {
                e.preventDefault();

                if(e.target.tagName.toUpperCase() == 'LABEL') {
                    $(this).find('textarea').focus();
                }
            },

            'focusin': function(e) {
                $(this).find('label').addClass('blind');
            },

            'focusout': function(e) {
                if($(this).find('textarea').val() == '') {
                    $(this).find('label').removeClass('blind');
                }
            }
        });
    }
};


/* 개편 기능 삭제*/
/**
 * 커스텀 폼 요소 (selectbox, checkbox, radiobutton) wrapper
 */
var FormWrapper = {
    targets: [],


    // 해당 폼 요소를 모두 새로고침하여 스타일을 업데이트 함
    // @param {string|object} formSelector [optional] 대상 폼 요소, 지정하지 않을시 커스텀 폼 요소 모두 새로고침함

    refreshAll: function (formSelector) {
        $.each(FormWrapper.targets, function (i, v) {
            //formSelector
            var targetToRefresh = ($.type(formSelector) !== "undefined") ? $(v).filter(formSelector) : $(v);

            targetToRefresh.trigger('refresh');
        });
    },

    load: function (options) {

        // init vars, options
        options = $.extend({
            containerSelector: '',
            formSelector: '',
            activeClassName: '',
            disabledClassName: ''
        }, options);

        var containerSelector = $(options.containerSelector);
        var forms = containerSelector.find(options.formSelector);

        // bind events
        containerSelector.on('refresh', options.formSelector, function (e) {
            var self = $(this);
            var container = $(e.delegateTarget);

            // selectbox
            if (self.is('select')) {

                // multiple select
                if (self.attr('multiple')) {

                    var multipleList = $();

                    self.children('option:selected').each(function (i, v) {
                        var current = $(v);
                        var currentWrap = current.parent('select');
                        var listID = currentWrap.attr('id') + '-' + current.val();

                        var tempList = $('<li id="' + listID + '">');
                        var contentLink = $('<a>').addClass('box').text(current.text());

                        var contentDelLink = $('<a>')
                            .addClass('del')
                            .attr('href', '#')
                            .data('multipleIndex', current.index())
                            .on('click', function (e) {
                                e.preventDefault();
                                self.children('option').eq($(this).data('multipleIndex')).prop('selected', false);
                                $(this).parent('li').remove();
                            });

                        var contentSpan = $('<span>').addClass('sp_com').text(current.text() + ' 검색어 삭제');

                        contentDelLink.append(contentSpan);
                        tempList.append(contentLink).append(contentDelLink);

                        multipleList = multipleList.add(tempList);
                    });

                    var listbox = container.next('ul.ds_schlist');

                    listbox.empty().append(multipleList);
                }

                // single select
                else {
                    var labelArea = container.find('.cc_ellip_in');
                    var optionList = self.find('option');

                    if (optionList.filter(':selected').val() != '') {
                        labelArea.addClass('selected');
                    } else {
                        labelArea.removeClass('selected');
                    }

                    labelArea.text(optionList.filter(':selected').text());
                }

            // checkbox, radiobutton
            } else {
                // active style class
                //if (self.is(':checked, :selected')) {
                if (self.is(':checked')) {
                    container.addClass(options.activeClassName);
                } else {
                    container.removeClass(options.activeClassName);
                }
            }

            // disabled style class
            if (self.is(':disabled')) {
                container.addClass(options.disabledClassName);
            } else {
                container.removeClass(options.disabledClassName);
            }
        });

        // select[multiple]인 경우
        // 다중선택 select 태그인 경우 click이벤트가 주어지는 경우 펼쳐져있는 모양때문에
        // 의도치 않게 option이 선택되는 문제가 있어 form요소를 click하더라도
        // 기본 기능이 동작하지 않도록 트릭을 적용함
//        forms.filter('select[multiple]').css({
//            width: 1,
//            height: 1
//        });

        containerSelector.on('click', function (e) {
            if (e.type === 'click') {
                var targetForm = $(this).find(options.formSelector).eq(0);
                if($.type( targetForm.get(0).click) === 'function'){
                    targetForm.get(0).click();
                }
//                if(targetForm.is('select[multiple]')) {
//                    targetForm.get(0).focus();
//                } else {
//                    targetForm.get(0).click();
//                }
            }
        });

        forms.on('change', function (e) {
            var targetToRefresh = $(e.target);

            // for radio button group
            if ($(e.target).is(':radio') && e.target.name) {
                if (e.target.form) {
                    targetToRefresh = $(e.target.form).find('[name="' + e.target.name + '"]:radio');
                } else {
                    targetToRefresh = $('[name="' + e.target.name + '"]:radio');
                }
            }

            targetToRefresh.trigger('refresh');
        });

        // init style
        forms.trigger('refresh');

        // add to targets array
        FormWrapper.targets.push(forms);
    }
};


/**
 * 로딩인디케이터
 */
var LoadingIndicator = {
    act: null,

    load: function() {
        if(!this.act) {
            this.act = new LoadingIndicator.model();
        }

        return this.act;
    },

    model: function(options) {

        options = $.extend({

        }, options);

        var oFloating;
        var oFloatingLayer;
        var loadingWrapper;
        var ajaxCallStackCount = 0;

        var self = this;

        var _validation = function() {

            // validation
            // check required libraries
            // $.fn.spin
            if(!$.fn.spin) {
                return false;
            }

            // check isApp
            if(typeof isApp !== 'undefined' && isApp === 'Y') {
                return false;
            }

            if(FloatingLayer === undefined) {
                return false;
            }

            loadingWrapper = $('.loading_wrapper');

            return true;
        };

        var _setLayout = function() {
            // start to make loading indicator
            // make wrapper and append
            if(loadingWrapper.length <= 0) {
                loadingWrapper = $('<div class="loading_wrapper"><div class="loading_bg"></div></div>');
                $('body').append(loadingWrapper);
            }

            // init jindo floating layer
            oFloating = new jindo.m.LayerPosition(loadingWrapper.get(0), {
                sPosition: 'center'
            });

            oFloatingLayer = $(oFloating.getLayer());

            oFloatingLayer.spin({
                lines: 11, // The number of lines to draw
                length: 4, // The length of each line
                width: 3, // The line thickness
                radius: 6, // The radius of the inner circle
                corners: 1, // Corner roundness (0..1)
                rotate: 0, // The rotation offset
                direction: 1, // 1: clockwise, -1: counterclockwise
                color: '#fff', // #rgb or #rrggbb or array of colors
                speed: 1, // Rounds per second
                trail: 60, // Afterglow percentage
                shadow: false, // Whether to render a shadow
                hwaccel: false, // Whether to use hardware acceleration
                className: 'spinner', // The CSS class to assign to the spinner
                zIndex: 2e9, // The z-index (defaults to 2000000000)
                top: 'auto', // Top position relative to parent in px
                left: 'auto' // Left position relative to parent in px
            });
        };

        var _init = function() {

            if(!_validation()) {
                return false;
            }

            _setLayout();
        };

        this.ajaxSetupEveryTransaction = function() {
            $.ajaxSetup({
                beforeSend: function() {
                    if(ajaxCallStackCount++ <= 0) {
                        self.show();
                    }
                },

                complete: function() {
                    if(--ajaxCallStackCount <= 0) {
                        self.hide();
                    }
                }
            });
        };

        this.show = function() {
            oFloatingLayer.show();
        };

        this.hide = function() {
            oFloatingLayer.hide();
        };

        _init();
    }
};



/**
 * ui-base main
 */
$(function(){
    /**
     * .ssg-toggle selector에 기본 토글 기능을 넣음
     * @type {Toggler}
     */
    var ssgToggle = new Toggler();

    /**
     * textarea용 fake placeholder
     */
    Placeholder.load('span.txtarea');

    /**
     * CheckBox
     */
    FormWrapper.load({
        containerSelector: 'span.inpchk',
        formSelector: ':checkbox',
        activeClassName: 'chk_checked',
        disabledClassName: 'disabled'
    });

    /**
     * RadioButton
     */
    FormWrapper.load({
        containerSelector: 'span.inprdo',
        formSelector: ':radio',
        activeClassName: 'rdo_checked',
        disabledClassName: 'disabled'
    });

    /**
     * SelectBox
     */
    FormWrapper.load({
        containerSelector: 'span.des_select',
        formSelector: 'select',
        activeClassName: 'selected',
        disabledClassName: 'disabled'
    });

    // 수량 체크 스크립트
    var welOpaArea =  $('.opa_area'),
        welSelects = welOpaArea.find('select');

    if(welSelects.length > 0){
        welSelects.on('change', function() {
            var sOptionSelected = $(this).find('option:selected');
            $(this).parents('.opa_area').find('.opa_tx').text(sOptionSelected.val());
        });
    }
});